import { create } from "zustand";

import { Image, Track, Video } from "@/data/types";
import { Network } from "@/lib/chains";

interface DeleteTagDialogConfig {
  name: "delete-tag";
  params: {
    tagId: string;
  };
}

interface DeleteSKUDialogConfig {
  name: "delete-sku";
  params: {
    skuId: string;
  };
}

interface TransferSKUDialogConfig {
  name: "transfer-sku";
  params: {
    skuId: string;
  };
}

interface ResequenceSKUDialogConfig {
  name: "resequence-sku";
  params: {
    skuId: string;
  };
}

interface ConfirmBlockchainDialogConfig {
  name: "confirm-blockchain";
  params: {
    skuId: string;
    tokenName: string;
    tokenSymbol: string;
    chainId: Network;
    currentGas?: number;
    gasLow?: boolean;
  };
}

interface AssetSizeDialogConfig {
  name: "asset-size";
}

interface DeleteOrganizationDialogConfig {
  name: "delete-organization";
  params: {
    organizationName: string;
    workOSOrganizationId: string;
  };
}
interface DeleteVerificationTypeDialogConfig {
  name: "delete-verification-type";
  params: {
    verificationTypeName: string;
    verificationTypeId: string;
  };
}

interface UpdateVideoDialogConfig {
  name: "update-video";
  params: Video;
}

interface DeleteVideoDialogConfig {
  name: "delete-video";
  params: Video;
}

interface UpdateImageDialogConfig {
  name: "update-image";
  params: Image;
}

interface DeleteImageDialogConfig {
  name: "delete-image";
  params: Image;
}

interface DeleteTrackDialogConfig {
  name: "delete-track";
  params: Track;
}

interface UpdateTrackDialogConfig {
  name: "update-track";
  params: Track;
}

interface MoveTagsDialogConfig {
  name: "move-tags";
  params: {
    skuId: string;
    tagCount: number;
  };
}

// FIXME: Because of the context structure, we need to pass the delete
// functions to these dialogs if we must maintain the current data flow.
// The transition to global save states and using zustand should fix this.

interface DeleteCMSTabDialogConfig {
  name: "delete-cms-tab";
  params: { onDelete: () => void };
}

interface DeletePlaylistTrackDialogConfig {
  name: "delete-playlist-track";
  params: {
    onDelete: () => void;
  };
}

interface DeleteGalleryItemDialogConfig {
  name: "delete-gallery-item";
  params: {
    tabIndex: number;
    itemIndex: number;
    onDelete: () => void;
  };
}

export type AppDialog =
  | DeleteTagDialogConfig
  | DeleteSKUDialogConfig
  | TransferSKUDialogConfig
  | ResequenceSKUDialogConfig
  | ConfirmBlockchainDialogConfig
  | AssetSizeDialogConfig
  | DeleteOrganizationDialogConfig
  | DeleteVerificationTypeDialogConfig
  | MoveTagsDialogConfig
  | UpdateVideoDialogConfig
  | DeleteVideoDialogConfig
  | UpdateImageDialogConfig
  | DeleteImageDialogConfig
  | UpdateTrackDialogConfig
  | DeleteTrackDialogConfig
  | DeletePlaylistTrackDialogConfig
  | DeleteCMSTabDialogConfig
  | DeleteGalleryItemDialogConfig;

interface DialogState {
  dialog?: AppDialog;
  openDialog: (dialog: AppDialog) => void;
  closeDialog: () => void;
}

export const useDialogState = create<DialogState>((set) => ({
  dialog: undefined,
  openDialog: (dialog: AppDialog) => {
    set({ dialog });
  },
  closeDialog: () => {
    set({ dialog: undefined });
  },
}));
